import PropTypes from 'prop-types';
import React from 'react';
import { bindAll } from '@bibliocommons/utils-react';
import InlineOverlayContext from 'app/components/shared/InlineOverlay/InlineOverlayContext';

class InlineOverlayCloseButton extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    bindAll(this);
  }

  handleClose(e) {
    e.preventDefault();

    if (this.props.handleClose) {
      this.props.handleClose();
    }

    if (this.context.handleClose) {
      this.context.handleClose();
    }
  }

  render() {
    return (
      <a href="#close-inline-overlay" className={this.props.className} onClick={this.handleClose}>
        {this.props.children}
      </a>
    );
  }
}

InlineOverlayCloseButton.propTypes = {
  handleClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string
};

InlineOverlayCloseButton.contextType = InlineOverlayContext;

InlineOverlayCloseButton.displayName = 'InlineOverlayCloseButton';

export default InlineOverlayCloseButton;
